/**
 * Storage Service for localStorage and sessionStorage
 */
class StorageService {
  private getStorage(kind: 'local' | 'session'): Storage | undefined {
    const g: any = typeof globalThis !== 'undefined' ? globalThis : undefined;
    if (!g) return undefined;
    if (kind === 'local') return g?.localStorage ?? g?.window?.localStorage;
    return g?.sessionStorage ?? g?.window?.sessionStorage;
  }
  /**
   * Set item in localStorage
   */
  set(key: string, value: string): void {
    try {
      const storage = this.getStorage('local');
      if (storage && typeof storage.setItem === 'function') {
        storage.setItem(key, value);
      }
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error);
    }
  }

  /**
   * Get item from localStorage
   */
  get(key: string): string | null {
    try {
      const storage = this.getStorage('local');
      if (storage && typeof storage.getItem === 'function')
        return storage.getItem(key);
    } catch (error) {
      console.error(`Error getting localStorage key "${key}":`, error);
    }
    return null;
  }

  /**
   * Remove item from localStorage
   */
  remove(key: string): void {
    try {
      const storage = this.getStorage('local');
      if (storage && typeof storage.removeItem === 'function')
        storage.removeItem(key);
    } catch (error) {
      console.error(`Error removing localStorage key "${key}":`, error);
    }
  }

  /**
   * Clear all localStorage
   */
  clear(): void {
    try {
      const storage = this.getStorage('local');
      if (storage && typeof storage.clear === 'function') storage.clear();
    } catch (error) {
      console.error('Error clearing localStorage:', error);
    }
  }

  /**
   * Set item in sessionStorage
   */
  setSession(key: string, value: string): void {
    try {
      const storage = this.getStorage('session');
      if (storage && typeof storage.setItem === 'function')
        storage.setItem(key, value);
    } catch (error) {
      console.error(`Error setting sessionStorage key "${key}":`, error);
    }
  }

  /**
   * Get item from sessionStorage
   */
  getSession(key: string): string | null {
    try {
      const storage = this.getStorage('session');
      if (storage && typeof storage.getItem === 'function')
        return storage.getItem(key);
    } catch (error) {
      console.error(`Error getting sessionStorage key "${key}":`, error);
    }
    return null;
  }

  /**
   * Remove item from sessionStorage
   */
  removeSession(key: string): void {
    try {
      const storage = this.getStorage('session');
      if (storage && typeof storage.removeItem === 'function')
        storage.removeItem(key);
    } catch (error) {
      console.error(`Error removing sessionStorage key "${key}":`, error);
    }
  }

  /**
   * Clear all sessionStorage
   */
  clearSession(): void {
    try {
      const storage = this.getStorage('session');
      if (storage && typeof storage.clear === 'function') storage.clear();
    } catch (error) {
      console.error('Error clearing sessionStorage:', error);
    }
  }
}

export const storageService = new StorageService();
